const totalCostDisplay = document.getElementById('totalCost');
const sliderInputNumber = document.getElementById('slider_input');
const sliderThumbNumber = document.getElementById('slider_thumb');
const sliderLineNumber = document.getElementById('slider_line');
const sliderInputMonth = document.getElementById('slider_input2');
const sliderThumbMonth = document.getElementById('slider_thumb2');
const sliderLineMonth = document.getElementById('slider_line2');
const contactQuotation = document.getElementById('quotation');
const toggleCheck = document.getElementById('check');
const enableText = document.getElementById('enable');
const disableText = document.getElementById('disable');
const calcButtonText = document.querySelector('.calculator .btn--rocket-inner');
const calcButton = document.querySelector('.calculator__btn');

let months = ['1 Month','3 Month','6 Month','12 Month'];

let translateObject = {
    'param_1':'Costs:',
    'param_2':'Order',
    'param_3':'Contact us for a customized quotation',
    'param_4':'Contact us',
    'param_5':'Free',
}

if ( window.location.pathname === '/nl/price/') {
    translateObject = {
        'param_1':'Kosten:',
        'param_2':'Bestelling',
        'param_3':'Contacteer ons voor een offerte op maat',
        'param_4':'Contacteer ons',
        'param_5':'Gratis',
    };

    months = ['1 Maand','3 Maanden','6 Maanden','12 Maanden']
}

let multiply = 1;

if (document.querySelector('.calculator')) {
    function exedeedCounting(numbers, basePrice, exedeedPrice) {
        if (numbers <= 10) {
            totalCostDisplay.innerText = `€${basePrice * multiply}`;
        }
        if (numbers > 10 && numbers < 250) {
            totalCostDisplay.innerText = `€${(basePrice + ((numbers - 10) * exedeedPrice)) * multiply}`;
            contactQuotation.innerText = `${translateObject.param_1}`;
            calcButtonText.innerText = `${translateObject.param_2}`;
        } else {
            if (numbers > 250) {
                totalCostDisplay.innerText = '';
                contactQuotation.innerText = `${translateObject.param_3}`;
                calcButtonText.innerText = `${translateObject.param_4}`;

                sliderThumbNumber.innerHTML = '250+';
            }
        }
    }

    function updateTotalCost() {
        const monthCount = parseInt(sliderInputMonth.value, 10);
        const numberCount = parseInt(sliderInputNumber.value, 10);

        if (monthCount === 0) {
            totalCostDisplay.innerText = `${translateObject.param_5}`;
            contactQuotation.innerText = `${translateObject.param_1}`;

            if (numberCount > 250) {
                sliderThumbNumber.innerHTML = '250+';
            }
        } else if (monthCount === 1) {
            exedeedCounting(numberCount, 195, 9);
        } else if (monthCount === 2) {
            exedeedCounting(numberCount, 345, 14);
        } else if (monthCount === 3) {
            exedeedCounting(numberCount, 495, 24);
        }
    }

    function showSliderValueNumbers(thumb, input, line) {
        thumb.innerHTML = input.value;

        const bulletPosition = (input.value / input.max);
        const space = input.offsetWidth - thumb.offsetWidth;

        thumb.style.left = (bulletPosition * space) + 'px';
        line.style.width = input.value / 2.6 + '%';

        if (parseInt(input.value) === 1 ) {
            thumb.style.left = '0px';
            line.style.width = '0px';
        }

        updateTotalCost();
    }

    function showSliderValueMonth(thumb, input, line) {
        const selectedValue = parseInt(input.value, 10);

        thumb.innerHTML = months[selectedValue];

        const bulletPosition = (input.value /input.max);
        const space = input.offsetWidth - thumb.offsetWidth;

        thumb.style.left = (bulletPosition * space) + 'px';
        line.style.width = input.value * 33.3 + '%';

        updateTotalCost();
    }

    showSliderValueNumbers(sliderThumbNumber, sliderInputNumber, sliderLineNumber);
    showSliderValueMonth(sliderThumbMonth, sliderInputMonth, sliderLineMonth);

    window.addEventListener('resize', () => {
        showSliderValueNumbers(sliderThumbNumber, sliderInputNumber, sliderLineNumber);
        showSliderValueMonth(sliderThumbMonth, sliderInputMonth, sliderLineMonth);
    });

    sliderInputNumber.addEventListener('input', () => {
        showSliderValueNumbers(sliderThumbNumber, sliderInputNumber, sliderLineNumber);
    }, false);

    sliderInputMonth.addEventListener('input', () => {
        showSliderValueMonth(sliderThumbMonth, sliderInputMonth, sliderLineMonth);
    }, false);

    // calculator toggle
    if (toggleCheck) {
        toggleCheck.addEventListener('change', event => {
            if (event.currentTarget.checked) {
                disableText.classList.add('check');
                enableText.classList.remove('check');
                multiply = 0.5;
                updateTotalCost();
            }
            else {
                disableText.classList.remove('check');
                enableText.classList.add('check');
                multiply = 1;
                updateTotalCost();
            }
        });
    }

    calcButton.addEventListener('click', () => {
        sessionStorage.setItem('contact-scroll', 'true');
    });
}
